


import React from "react";
import "./Insuarance_card.css";
import { Link, useNavigate } from "react-router-dom";
function Insuarance_card(props) {
  const showDiscount =
    props?.title === "CAR INSURANCE" || props?.title === "TERM INSURANCE";

  const navigate = useNavigate();

  return (
    <>
      <Link
        to={`/term-lifeinsurance?name=${props?.title}&type=INSURANCE`}
      >
        <div className="main_Insuarance_card">
          <div className="Insuarance_card">
            <div>
              {showDiscount && (
                <div className="insuarance_decount_text_holder">
                  <p>Upto 30% Discount</p>
                </div>
              )}
              <div className="img_holder">
                <img
                  className="insuarance_img"
                  src={process.env.PUBLIC_URL + props?.img}
                  alt="insuarance_img"
                />
              </div>

              <div className="text_holder">
                <p>{props?.title}</p>
              </div>
            </div>
          </div>
        </div>
      </Link>

      
    </>
  );
}

export default Insuarance_card;
